import { useSyncExternalStore } from "react";

const subscribeToConnectivity = (onChange: () => void) => {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
};

const getIsOnline = () => navigator.onLine;

// The server render never assumes offline
const getServerIsOnline = () => true;

// Live view of the browser's connectivity flag, correct from the very first client render so the error screen never briefly classifies an offline crash as a server failure; re-renders consumers on the online/offline events so the screen can recover the moment the connection returns.
export const useOnlineStatus = (): boolean =>
  useSyncExternalStore(subscribeToConnectivity, getIsOnline, getServerIsOnline);
